import * as types from './mutation-types'

export const fetchUsers = ({ commit, dispatch, state }, params) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`/api/user-managements`, { params }).then((response) => {
            commit(types.BOOTSTRAP_USERS, response.data.users.data)
            commit(types.SET_TOTAL_USERS, response.data.users.total)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
export const addUser = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('/api/user-managements', data).then((response) => {
            commit(types.ADD_USER, response.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
export const fetchEditUser = ({ commit, dispatch }, id) => {
  return new Promise((resolve, reject) => {
    window.axios.get(`/api/user-managements/${id}/edit`).then((response) => {
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}
export const updateUser = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.put(`/api/user-managements/${data.id}`, data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
